'use strict';

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

module.exports = /*#__PURE__*/function () {
  function ApiManager() {
    var _this = this;

    _classCallCheck(this, ApiManager);

    this._api = {};

    this._onUndef = function () {
      return undefined;
    };

    this.api = new Proxy(this._api, {
      get: function get(_, prop) {
        if (prop === 'then') return undefined; // Not a promise!

        return _this._api[prop] === undefined ? _this._onUndef(prop) : _this._api[prop];
      }
    });
  }

  _createClass(ApiManager, [{
    key: "update",
    value: function update(nextApi, onUndef) {
      var _this2 = this;

      var prevApi = _objectSpread({}, this._api);

      var prevUndef = this._onUndef;
      Object.keys(this._api).forEach(function (k) {
        delete _this2._api[k];
      });
      Object.assign(this._api, nextApi);
      if (onUndef) this._onUndef = onUndef;
      return {
        cancel: function cancel() {
          return _this2.update(prevApi, prevUndef);
        },
        api: this.api
      };
    }
  }]);

  return ApiManager;
}();